import { KnownDeliveryDtoDeliveryChannel } from '@groundfloor-platform/mgmt-service-g-sdk';
import { ChannelHandoff } from '../../../ui/components/pure/icons/ChannelHandoff.icon';
import { ChannelKiosk } from '../../../ui/components/pure/icons/ChannelKiosk.icon';
import { ChannelMobile } from '../../../ui/components/pure/icons/ChannelMobile.icon';
import { ChannelPortal } from '../../../ui/components/pure/icons/ChannelPortal.icon';
import { ChannelQR } from '../../../ui/components/pure/icons/ChannelQR.icon';
import { SVGIconComponent } from '../../../ui/components/pure/icons/types';

export const deliveryChannelToIcon: Record<KnownDeliveryDtoDeliveryChannel, SVGIconComponent> = {
  [KnownDeliveryDtoDeliveryChannel.Kiosk]: ChannelKiosk,
  [KnownDeliveryDtoDeliveryChannel.CourierApp]: ChannelMobile,
  [KnownDeliveryDtoDeliveryChannel.QR]: ChannelQR,
  [KnownDeliveryDtoDeliveryChannel.QrHandoff]: ChannelHandoff,
  [KnownDeliveryDtoDeliveryChannel.Cloud]: ChannelPortal,
  [KnownDeliveryDtoDeliveryChannel.External]: ChannelKiosk,
  [KnownDeliveryDtoDeliveryChannel.Unrecognised]: ChannelKiosk
};
